module.exports = __webpack_public_path__ + "static/SeedToSale@2x-7d29d0166f76cbd6875b2c1c1fe8a25a.png";